<template>
	<!-- アラート -->
	<VSonner position="bottom-right" />
	<!-- 画面ローディング -->
	<DetailCarLoader />

	<!-----------------------------------------------------------------------------
	 システムログイン前 レイアウト
	------------------------------------------------------------------------------>
	<div v-if="isLogin" class="l_login">
		<router-view />
	</div>

	<!-----------------------------------------------------------------------------
	 システムログイン後 管理画面セレクト レイアウト
	------------------------------------------------------------------------------>
	<div v-if="isMgmtSelect" class="l_layout">
		<!-- <div class="layout_bg">
			<div class="layout_bg_img">
				<img src="/img/logo.png" alt="" />
			</div>
		</div> -->
		<!-- コンテンツ表示 -->
		<router-view />
	</div>

	<!-----------------------------------------------------------------------------
	 システムログイン後 レイアウト
	------------------------------------------------------------------------------>
	<div v-if="isLoginAfter" class="l_layout">
		<!-- <div class="layout_bg">
			<div class="layout_bg_img">
				<img src="/img/logo.png" alt="" />
			</div>
		</div> -->

		<HeaderMenu
			:current-path="routePath"
			@info-check="infoCheck"
			@logout-modal="logoutModal"
		/>
		<!-- コンテンツ表示 -->
		<router-view />
	</div>

	<!-----------------------------------------------------------------------------
	 404 or 500 レイアウト
	------------------------------------------------------------------------------>
	<div v-if="isNotFound" class="flex h-full w-full items-center justify-center">
		<div class="layout_bg sizeS"></div>

		<router-view />
	</div>

	<!-- ログアウトモーダル -->
	<MoleLogoutModal
		:is-modal="logoutModalOpenFlag"
		@log-out="logOut"
		@modal-close="modalClose"
	/>
</template>

<script setup>
import HeaderMenu from "@/components/layouts/sales/HeaderMenu.vue";
import DetailCarLoader from "@/components/atoms/DetailCarLoader.vue";
import MoleLogoutModal from "@/components/molecules/modal/MoleLogoutModal.vue";
import { useRoute, useRouter } from "vue-router";
import { VSonner, toast } from "vuetify-sonner";
import { computed, onMounted, onUpdated, ref, watch } from "vue";
import "vuetify-sonner/style.css";
// stubs
import AuthUserStub from "@/stubs/AuthUser";
// utils
import toaster from "@/utils/Toaster.js";
import scrollControl from "@/utils/ScrollControl.js";
//store
import { useAuthStore } from "@/stores/AuthStore";
// api
import FunctionApi from "@/api/FunctionApi.js";

const authStore = useAuthStore();
const functionApi = new FunctionApi();
/* ---------------------------------------------------------------------------
utils
---------------------------------------------------------------------------- */
const { alert } = toaster();
const { parentScrollRemove } = scrollControl();
/* ---------------------------------------------------------------------------
	router
---------------------------------------------------------------------------- */
const route = useRoute();
const router = useRouter();
/* ---------------------------------------------------------------------------
data
---------------------------------------------------------------------------- */
const routePath = ref("");
const displayType = ref("");
const infoModalOpenFlag = ref(false);
const logoutModalOpenFlag = ref(false);

// パスをチェックする関数
const pathCheck = path => {
	const urlArray = path.split("/");
	routePath.value = urlArray[1];
};

async function logOut() {
	await functionApi.auth.logout().then(res => {
		authStore.isAuthenticated = false;
		authStore.user = { ...AuthUserStub };

		alert("logout");

		// ログイン画面に戻す
		router.push("/signin");
	});
}

// お知らせ確認
function infoCheck() {
	// 親要素のscroll非表示
	parentScrollRemove();
	infoModalOpenFlag.value = true;
}

// ログアウト
function logoutModal() {
	// 親要素のscroll非表示
	parentScrollRemove();
	logoutModalOpenFlag.value = true;
}

function modalClose() {
	infoModalOpenFlag.value = false;
	logoutModalOpenFlag.value = false;
}

// displayType を更新する関数
const updateDisplayType = metaColumn => {
	switch (metaColumn) {
		case "before_login":
			displayType.value = "loginBefore";
			break;

		case "mgmt_select":
			displayType.value = "mgmtSelect";
			break;

		case "after_login":
			displayType.value = "loginAfter";
			break;

		case "error":
			displayType.value = "notFound";
			break;
		default:
			displayType.value = "";
			break;
	}
};

// ルートの変更を監視し、対応する処理を実行
watch(route, () => {
	pathCheck(route.path);
	updateDisplayType(route.meta.column);
});

const isLogin = computed(() => displayType.value === "loginBefore");
const isMgmtSelect = computed(() => displayType.value === "mgmtSelect");
const isLoginAfter = computed(() => displayType.value === "loginAfter");
const isNotFound = computed(() => displayType.value === "notFound");

onMounted(() => {});
</script>
